/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentTracesFilter {
    getFixupPrototypeFunction() { return AIAgentTracesFilter.fixupPrototype; }

    static newInstance(model: Partial<AIAgentTracesFilter>): AIAgentTracesFilter {
        let obj = Object.assign(new AIAgentTracesFilter(), model);
        AIAgentTracesFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentTracesFilter>): AIAgentTracesFilter {
        if (!model) return null;
        return AIAgentTracesFilter.newInstance(<AIAgentTracesFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentTracesFilter) {
        if (!obj) return;

        models.AIAgentTracesFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentTracesFilter): boolean {
        Object.setPrototypeOf(obj, AIAgentTracesFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.attribute) {
            models.KeyValues.fixupPrototype(this.attribute);
        }
    }

    /**
     * AgentCore runtime ID whose spans are listed
     */
    agent_id: string;

    /**
     * Agent name (aws.local.service) for external agents that have no runtime ID. Provide either agent_id or agent_name.
     */
    agent_name: string;

    /**
     * Start of the time range
     */
    start_date: Date;

    /**
     * End of the time range
     */
    end_date: Date;

    /**
     * Optional span-attribute filter
     */
    attribute: models.KeyValues;

    /**
     * When true, omits pure transport spans (HTTP/RPC hops with no GenAI work). Matches the timeline's transport toggle.
     */
    exclude_transport_spans: boolean;

    /**
     * Restrict the listing to a single trace. Used by the trace detail view to load spans the timeline filtered out.
     */
    trace_id: string;

}
